import React from 'react'

class AccidentModalInsurance extends React.PureComponent {
  render() {
    return (
      <div>
        <p>
          We have dedicated accident aftercare specialists in every site apart
          from Ruislip, where we deal with claims remotely. We don’t just send
          an estimate, we deal with the whole claim from beginning to end
          because we know that if you’ve just been involved in an accident the
          last thing you want to do is spend hours on the phone explaining your
          situation again and again. With CitygateOne, you call us and we do the
          rest.
        </p>
      </div>
    )
  }
}

export default AccidentModalInsurance
